import TemplateBlogPost from './TemplateBlogPost'

export default TemplateBlogPost
